import { Component, inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BodensteckbriefEntry } from './listen.service';

/**
 * Steckbrief einer Hauptbodenform als Fenster ueber der Aufnahmemaske.
 *
 * Geoeffnet vom Katalog-Knopf am Feld „Hauptbodenform" (Bodenaufnahme und
 * Kurzprotokoll, Nutzer-Entscheidung 28.09.2026). Vorher fuehrte das (i) dort
 * per Seitenwechsel in den Katalog-Leser; man verliess also die Aufnahme.
 *
 * Gezeigt werden dieselben Bauteile wie im Leser: der Steckbrief und auf Wunsch
 * die Originalseite daneben. Wer weiterblaettern will, kommt ueber
 * „Im Katalog-Leser oeffnen" dorthin. Eine Hauptbodenform kann mehrere
 * Katalogseiten haben (z. B. 89/1 und 89/2); dann steht oben je Seite ein Knopf.
 */
@Component({
	standalone: false,
	selector: 'bp-steckbrief-fenster',
	templateUrl: './steckbrief-fenster.component.html',
	styleUrls: ['./steckbrief-fenster.component.css'],
})
export class SteckbriefFensterComponent {
	readonly aktiv = inject(NgbActiveModal);
	private router = inject(Router);

	/** Die Hauptbodenform, wie sie im Feld steht. */
	@Input() hbf = '';
	/** Alle Steckbriefe dieser Hauptbodenform, in der Reihenfolge des Katalogs. */
	@Input() steckbriefe: BodensteckbriefEntry[] = [];

	/** Welche Katalogseite gerade zu sehen ist. */
	index = 0;
	/** Originalseite daneben zeigen. */
	original = false;

	get aktuell(): BodensteckbriefEntry | undefined {
		return this.steckbriefe[this.index];
	}

	/** Name der gezeigten Seite - im Katalog steht dort z. B. „Sand-Braunerde (Teil 2/2)". */
	get titel(): string {
		return this.aktuell?.hauptbodenform?.name || this.hbf;
	}

	/** Beschriftung eines Seiten-Knopfs: die Katalogseite, sonst „Teil n". */
	seitenName(s: BodensteckbriefEntry, i: number): string {
		return s.seitenzahl ? `Seite ${s.seitenzahl}` : `Teil ${i + 1}`;
	}

	/** Eine Originalseite gibt es nur, wenn der Steckbrief sagt, woher er stammt. */
	hatOriginal(s: BodensteckbriefEntry | undefined): boolean {
		return !!s?.pdf && s.page != null;
	}

	/** Schliesst das Fenster und oeffnet die gerade gezeigte Seite im Katalog-Leser. */
	imKatalogLeser(): void {
		const s = this.aktuell;
		this.aktiv.close();
		void this.router.navigate(s ? ['/bodenformenkatalog', s.id] : ['/bodenformenkatalog']);
	}
}
